export enum QueryKey {
	CurrentEvent = 'oneOnOnes_currentEvent',
	CurrentOneOnOne = 'oneOnOnes_current',
	Participants = 'oneOnOnes_participants',
	Event = 'oneOnOnes_event',
	Meeting = 'oneOnOnes_meeting',
	Meetings = 'oneOnOnes_meetings',
	MeetingV2 = 'oneOnOnes_meetingV2',
	MeetingsV2 = 'oneOnOnes_meetingsV2',
	MeetingTimes = 'oneOnOnes_meetingTimes',
	Previous = 'oneOnOnes_previousMeeting',
	Reports = 'direct-reports',
	User = 'user',
	UserEvents = 'oneOnOnes_userEvents',
	Bonus = 'bonus',
	Feedback = 'feedback',
	MeetingBriefSummary = 'meeting_brief_summary',
	RecentActivity = 'recent_activity',
	Goal = 'goal',
	Goals = 'goals',
	TeamActivityDetails = 'team-activity-details',
	ReviewRecord = 'review-record',
	ReviewRecords = 'review-records',
}
